import { Fragment } from "react";
import { faClock } from "@fortawesome/free-solid-svg-icons/faClock";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import NavigationLink from "../navigation-link";
import { AbsolutePaths } from "constants/routes";
import { PageNames } from "types-for/routes";

/**
 * Link to the deferred queries screen.
 * @returns A link to the page.
 */
const DeferredQueriesLink = () => (
    <NavigationLink view={AbsolutePaths[PageNames.DeferredQueries]()}>
        <Fragment>
            <FontAwesomeIcon icon={faClock} />
            Deferred Queries
        </Fragment>
    </NavigationLink>
);

export default DeferredQueriesLink;
